<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/G7midf/tc-custom/9781630472863.jpg?1718282807241" alt="This image is the cover for the book Anonymous No More"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Anonymous No More
      </h1>
      <p class="bookDescription body article font2">
        <b>The inspiring, heartfelt story of o</b><b>ne mother’s faith-filled journey through addiction and recovery . . . to finally find redemption in God’s grace.</b><br/>  <br/> Alcohol and drugs took away what mattered most in this mother’s life . . . and a once promising future came to an abrupt halt as her addiction forced her into seclusion. Although she hoped to escape the entrapment of her drug dependence, the road to sobriety seemed full of unexpected road blocks and dead ends. Her situation seemed inescapable, but she would ultimately find the one true way to escape—and that way would supply her with everlasting life. Before the dangerous habits could do her in, her cry for help was heard and God placed this woman in the perfect hands so she could learn to live again. Discovering her identity in Christ, she became anonymous no more.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alisa Massey
      </h2>
      
      <p class="authorDescription body article">Alisa Massey is a rising Christian author and a proud mother and wife. Alisa has obtained her BA in Business Management, an MA in Organizational Leadership, and will acquire her master’s degree in Christian Studies from Grand Canyon University in 2015. She is member of the Golden Key International Honour Society and a member of the Association of Independent Authors. Alisa is also a certified Behavioral Rehabilitation Specialist. She lives in Oklahoma with her husband and together they have 4 lovely children. Alisa enjoys traveling with her family, reading, writing, and helping others.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?64504404